import { sqliteTable, text, real, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// purchase_orders — ใบสั่งซื้อ (Purchase Order)
// ============================================================================
export const purchaseOrders = sqliteTable("purchase_orders", {
  id: text("id").primaryKey(), // ULID
  poNo: text("po_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  partyType: text("party_type", {
    enum: ["supplier"],
  }).notNull().default("supplier"),
  partyId: text("party_id").notNull(),
  poDate: text("po_date").notNull(),
  expiryDate: text("expiry_date"),
  subtotal: real("subtotal").notNull().default(0),
  taxAmount: real("tax_amount").notNull().default(0),
  total: real("total").notNull().default(0),
  status: text("status", {
    enum: [
      "draft",
      "submitted",
      "approved",
      "partially_received",
      "received",
      "partially_billed",
      "invoiced",
      "cancelled",
    ],
  })
    .notNull()
    .default("draft"),
  convertedToInvoiceId: text("converted_to_invoice_id"),
  remarks: text("remarks"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedBy: text("updated_by"),
  updatedAt: text("updated_at").notNull(),
  deletedBy: text("deleted_by"),
  deletedAt: text("deleted_at"),
}, (table) => ({
  companyStatusIdx: index("po_company_status_idx").on(table.companyId, table.status, table.poDate),
  companyPartyIdx: index("po_company_party_idx").on(table.companyId, table.partyId),
  convertedIdx: index("po_converted_idx").on(table.convertedToInvoiceId),
}));

// Type exports
export type PurchaseOrder = typeof purchaseOrders.$inferSelect;
export type NewPurchaseOrder = typeof purchaseOrders.$inferInsert;
